import { ILightWeightArea } from '../models';
import { flattenSimple } from '@fi-shared/utils/flatten-simple';
import { fiIntersection } from '@fi-shared/utils/fi-intersection';

export function fiGetSelectedAreaIdsForFilter(
    availableAreas: ILightWeightArea[],
    selectedIds: number[],
    isSubArea?: boolean,
): number[] {
    if (!selectedIds?.length) return [];

    return availableAreas
        ?.filter((area: ILightWeightArea) => {
            return selectedIds?.includes(area.Id) && (isSubArea ? !!area.ParentId : !area.ParentId);
        })
        .map((area: ILightWeightArea) => area.Id);
}

export function getSelectedItemIdsFoldableData<T extends { Id: number; ChildItems: T[] }>(
    selectedIds: number[],
    availableItems: T[],
): {
    selectedItemIds: number[];
    selectedChildItemIds: number[];
} {
    const mainItemIds: number[] = availableItems.map((item) => item.Id);
    const childItemIds: number[] = flattenSimple(
        availableItems.map((item) => item.ChildItems.map((childItem) => childItem.Id)),
    );
    const selectedItemIds: number[] = fiIntersection(mainItemIds, selectedIds);
    const selectedChildItemIds: number[] = fiIntersection(childItemIds, selectedIds);
    return {
        selectedItemIds,
        selectedChildItemIds,
    };
}
